var e=()=>({get(){},set(){}});export{e as nil};
//# sourceMappingURL=index.js.map
